import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition, SubTask } from "../common/models";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";

const TUTORIAL_URLS: Record<string, string> = {
  'en': 'assets/videos/tutorials/Picture_Description.mp4',
  'es-419': 'assets/videos/tutorials/Picture_Description-es-419.mp4'
}

const PICTURE_SOURCES: Record<string, Record<string, string>> = {
  "en": {
    "option1": 'assets/images/PictureDescriptionTaskPicture1.png',
    "option2": 'assets/images/PictureDescriptionTaskPicture2.jpg',
  },
  "es-419": {
    "option1": 'assets/images/PictureDescriptionTaskPicture1-es-419.png',
    "option2": 'assets/images/PictureDescriptionTaskPicture2-es-419.png',
  }
};


const Definition: AcousticTaskDefinition = {
  name: "Picture description",
  title: "Picture description",
  description: "This task helps us analyze features in your voice.",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '1:10',
  subTaskDefinitions: [{
    name: "Picture description-option1",
    title: "",
    instructions: `Tell me everything you see going on in this picture.`,
    profileName: 'speech',
    content: null
  }, {
    name: "Picture description-option2",
    title: "",
    instructions: `Describe everything that is happening in the picture (as though describing it for the blind), trying to use complete sentences.`,
    profileName: 'speech',
    content: null
  }
]
};
export const PictureDescriptionDefinition = Definition;

export const PictureDescription =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();

  const getPictureSource = (option: string): string => {
    return PICTURE_SOURCES[i18n.language][option]
  };

  const getSubTasks = (option: string): SubTask[] => {
      console.log("Selected option:", option);
      const filteredSubTasks = option === 'option1'
        ? [Definition.subTaskDefinitions[0]]
        : [Definition.subTaskDefinitions[1]];

      return filteredSubTasks.map((definition) => ({
        ...definition,
        content: (
          <img
            src={getPictureSource(option)}
            alt="subTak"
            className="subTak-image"
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '600px'
            }}
          />
        ),
        id: randomUUID(),
        instructions: translateReactNode(definition.instructions, Definition.cohort),
        title: translateReactNode(definition.title, Definition.cohort) as string
      }));
  };

  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: getSubTasks(Math.round(Math.random()) === 0 ? 'option1' : 'option2'),
    tutorialUrl: TUTORIAL_URLS[i18n.language] || TUTORIAL_URLS['en']
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
      />
    </div>
  );
}
